export const extractCity = (district: string): string | null => {
  // Handle special administrative regions like '香港特别行政区', '澳门特别行政区'
  const specialRegions = /(香港特别行政区|澳门特别行政区)/;
  const specialMatch = district.match(specialRegions);
  if (specialMatch) return specialMatch[1];

  // Regular expression to match patterns like 'xx省yy市' or just 'yy市'
  const cityMatch = district.match(/(?:省)?([\u4e00-\u9fa5]{2,}市)/);
  return cityMatch ? cityMatch[1] : null;
};

export const extractCoordinates = (location?: string): [number, number] => {
  if (!location || !location.includes(",")) return [0, 0];

  const [lng, lat] = location.split(",");
  return [parseFloat(lng) || 0, parseFloat(lat) || 0];
};

export const formatUseCarTime = (useCarTime: string): string => {
  // Create a Date object from the input string
  const date = new Date(useCarTime);

  // Helper function to pad single digits with a leading zero
  const pad = (num: number) => num.toString().padStart(2, '0');

  // Format the date as "YYYY-MM-DD HH:mm:00"
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:00`;
}

export const validateLocationInput = (locationDistrict: string, destinationDistrict: string): boolean => {
  // Extract province information
  const extractProvince = (district: string): string | null => {
    const provinceMatch = district.match(/([\u4e00-\u9fa5]+(?:省|自治区|特别行政区))/);
    return provinceMatch ? provinceMatch[1] : null;
  };

  // Special handling for Hong Kong and Macau
  const isHongKong = locationDistrict.includes("香港") || locationDistrict.includes("Hong Kong");
  const isMacau = locationDistrict.includes("澳门") || locationDistrict.includes("Macau");
  const isDestHongKong = destinationDistrict.includes("香港") || destinationDistrict.includes("Hong Kong");
  const isDestMacau = destinationDistrict.includes("澳门") || destinationDistrict.includes("Macau");

  // Check if both are in Hong Kong or both in Macau
  if ((isHongKong && isDestHongKong) || (isMacau && isDestMacau)) {
    return false;
  }

  // Extract provinces
  const locationProvince = extractProvince(locationDistrict);
  const destinationProvince = extractProvince(destinationDistrict);

  // If both are in Guangdong
  if (locationProvince === "广东省" && destinationProvince === "广东省") {
    return false;
  }

  // If both are outside of Hong Kong, Macau and Guangdong
  if (
    (!isHongKong && !isMacau && locationProvince !== "广东省") ||
    (!isDestHongKong && !isDestMacau && destinationProvince !== "广东省")
  ) {
    return false;
  }

  // Valid cross-border route
  return true;
};